module.exports = __webpack_public_path__ + "img/slim_cleanstation26.28d74ece.jpg";